import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7df107fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7df107fe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df107fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df107fe')) {
      api.createRecord('7df107fe', component.options)
    } else {
      api.reload('7df107fe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7df107fe&scoped=true", function () {
      api.rerender('7df107fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm_fine/views/activity_center/components/register_button/index.vue"
export default component.exports